import { Link } from "react-router-dom";
import { LOGO_URL } from "@/data/site";
import { Instagram, Linkedin, Youtube, ArrowUpRight } from "lucide-react";
import Marquee from "react-fast-marquee";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative bg-forest-950 text-ivory overflow-hidden">
            <div className="border-t border-white/10">
                <Marquee gradient={false} speed={40} className="py-8 md:py-12">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <span
                            key={i}
                            className="font-serif-display italic text-[3.5rem] md:text-[6rem] leading-none tracking-tight mx-10 text-ivory/95"
                        >
                            KLiving &nbsp;·&nbsp;
                            <span className="text-lime">Architecting quiet luxury</span>
                            &nbsp;·&nbsp;
                        </span>
                    ))}
                </Marquee>
            </div>

            <div className="border-t border-white/10">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <div className="mb-5">
                            <div className="h-20 w-auto inline-flex items-center">
                                <img src={LOGO_URL} alt="KLiving" className="h-full w-auto object-contain logo-white" />
                            </div>
                        </div>
                        <p className="text-ivory/60 text-sm leading-relaxed max-w-sm">
                            Curating iconic residences and commercial landmarks across Odisha —
                            under forty projects, ever, by design.
                        </p>

                        <div className="mt-8 flex items-center gap-3">
                            {[
                                { Icon: Instagram, label: "Instagram" },
                                { Icon: Linkedin, label: "LinkedIn" },
                                { Icon: Youtube, label: "YouTube" },
                            ].map(({ Icon, label }) => (
                                <a
                                    key={label}
                                    href="#"
                                    data-testid={`footer-social-${label.toLowerCase()}`}
                                    aria-label={label}
                                    className="h-10 w-10 border border-ivory/15 flex items-center justify-center hover:border-lime hover:text-lime transition-colors"
                                >
                                    <Icon size={16} />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="md:col-span-2">
                        <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime/80 mb-5">
                            Discover
                        </div>
                        <ul className="space-y-3 text-sm">
                            {[
                                { to: "/projects", l: "All projects" },
                                { to: "/projects?filter=ongoing", l: "Ongoing" },
                                { to: "/projects?filter=completed", l: "Completed" },
                                { to: "/projects?filter=upcoming", l: "Upcoming" },
                            ].map((x) => (
                                <li key={x.to}>
                                    <Link to={x.to} className="hover-underline text-ivory/75 hover:text-ivory">
                                        {x.l}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="md:col-span-2">
                        <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime/80 mb-5">
                            Studio
                        </div>
                        <ul className="space-y-3 text-sm">
                            {[
                                { to: "/about", l: "About" },
                                { to: "/amenities", l: "Amenities" },
                                { to: "/journal", l: "Journal" },
                                { to: "/careers", l: "Careers" },
                                { to: "/contact", l: "Contact" },
                            ].map((x) => (
                                <li key={x.to}>
                                    <Link to={x.to} className="hover-underline text-ivory/75 hover:text-ivory">
                                        {x.l}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime/80 mb-5">
                            Say hello
                        </div>
                        <a
                            href="mailto:hello@kliving.co"
                            data-testid="footer-email-link"
                            className="font-serif-display text-3xl md:text-4xl inline-flex items-center gap-3 hover-underline"
                        >
                            hello@kliving.co
                            <ArrowUpRight size={26} strokeWidth={1.25} />
                        </a>
                        <div className="mt-6 text-ivory/60 text-sm leading-relaxed">
                            MGM Heights, Plot 140/9957<br />
                            K Living — 3rd floor, Kalinga Nagar<br />
                            Bhubaneswar 751003, Odisha<br />
                            +91 674 000 0000
                        </div>
                    </div>
                </div>
                <div className="border-t border-white/10">
                    <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-ivory/50 font-mono-mini tracking-[0.18em] uppercase">
                        <span>© {new Date().getFullYear()} KLiving Developers Pvt. Ltd. · Bhubaneswar, Odisha</span>
                        <span>Crafted with intention · India</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
